interface ConditionalComponentProps {
  condition: boolean
  children: React.ReactNode
}

export const ConditionalComponent: React.FC<ConditionalComponentProps> = ({
  condition,
  children,
}) => (condition ? <>{children}</> : null)
